import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/ui-custom/Reveal";

export const CategoryStrip = ({ categories = [] }) => {
  const cats = categories.filter((c) => c.brand_count > 0);
  return (
    <section className="py-24 lg:py-32" data-testid="category-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <SectionHeading eyebrow="What we supply" title="Every corner of the gourmet aisle." description="From wholesale deli meats, smallgoods and cheese to antipasto, olive oil, pasta, sauces, frozen and heat-and-serve bakery, Deliver supplies the categories independent supermarkets, delis and foodservice kitchens rely on. Each category page explains what we stock and who it suits." />
          <Reveal delay={0.2}>
            <Link to="/brands" className="btn-pill btn-outline shrink-0" data-testid="category-view-all">Browse the range <ArrowRight size={14} /></Link>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="mt-12 flex flex-wrap gap-3" data-testid="category-chips-home">
          {cats.map((c) => (
            <Link key={c.slug} to={`/range/${c.slug}`} data-testid={`category-link-${c.slug}`} className="chip !px-6 !py-3 !text-base !text-[var(--ink)] hover:!bg-[var(--ink)] hover:!text-[var(--cream)]">
              {c.name}
            </Link>
          ))}
        </Reveal>
      </div>
    </section>
  );
};
